// @ts-nocheck


import findKey from 'lodash/findKey';
import React from 'react';
import { vehicleGroupEnum, vehicleGroups, vehicleTypeEnum } from '../../lib/enum';


import { vehicleTypesPlainTree, vehicleTypesTree } from '../../lib/vehicleTypesTree';
import { Select } from '../ant/Select';
import TreeSelect from './../ui/TreeSelect';











































/**
 * Компонент выбора типов ТС, разбитых по видам ТС
 */
export default class VehicleTypeSelect extends React.Component {
  state = {
    value: this.props.value
  };

  static defaultProps = {
    selectableGroup: false,
    resultAsObject: false
  };

  getTree = () => {
    const {
      onlyTypes,
      excludeGroups,
      selectableGroup,
      nonSelectableGroups
    } = this.props;
    const preparedTree = vehicleTypesTree.
    filter((node) => {
      if (onlyTypes) {
        // Оставляем только те виды ТС, для которых указаны типы из onlyTypes
        return node.children.some((child) => onlyTypes.includes(child.value));
      }
      if (excludeGroups) {
        return !excludeGroups.includes(node.value);
      }
      return true;
    }).
    map((node) =>
    // Оставляем только указанные типы ТС
    onlyTypes ?
    {
      ...node,
      children: node.children.filter((child) =>
      onlyTypes.includes(child.value)
      )
    } :
    node
    );
    // Делаем виды ТС выбираемыми или невыбираемыми
    return preparedTree.map((node) => ({
      ...node,
      selectable: nonSelectableGroups ?
      !nonSelectableGroups.includes(node.value) :
      selectableGroup
    }));
  };

  onChangeNode = (value) => {
    const { onChange } = this.props;
    this.setState({ value });
    if (this.props.resultAsObject) {
      // В данном случае заполняется либо группа, либо тип
      onChange(
        {
          group: vehicleGroupEnum[value],
          type: vehicleTypeEnum[value]
        }
      );
    } else if (vehicleGroupEnum[value]) {
      // Если выбрали родительский узел
      onChange(vehicleTypesPlainTree[value]);
    } else {
      onChange(value);
    }
  };

  componentDidUpdate(prevProps) {
    const { value: propsValue } = this.props;
    if (propsValue !== prevProps.value) {
      if (Array.isArray(propsValue)) {
        const value = findKey(vehicleTypesPlainTree, (value) =>
        value.some((type) => propsValue.includes(type))
        );
        this.setState({ value });
      } else {
        this.setState({ value: propsValue });
      }
    }
  }

  render() {
    const { value } = this.state;
    const {
      onlyTypes,
      excludeGroups,
      selectableGroup,
      nonSelectableGroups,
      onlyGroups,
      resultAsObject,
      onChange,
      ...props
    } = this.props;
    const tree = this.getTree();
    return onlyGroups ?
    <Select
      allowClear
      value={value}
      onChange={(value) => onChange && onChange(vehicleGroupEnum[value])}
      {...props}>

        {Object.keys(vehicleGroupEnum).map((vehicleGroup) =>
      <Select.Option key={vehicleGroup} value={vehicleGroup}>
            {vehicleGroups[vehicleGroup]}
          </Select.Option>
      )}
      </Select> :

    <TreeSelect
      placeholder="Выберите тип ТС"
      showSearch
      treeNodeFilterProp="title"
      allowClear
      treeData={tree}
      {...props}
      value={value}
      onChange={this.onChangeNode} />;


  }
}
